import { useTranslation } from 'react-i18next';
import { ListCacheManager } from '@/data/hook/query/v2/CacheFacade';
import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';
import { StudentsReportsTable } from '@/components/scheduled-lesson-report/StudentsReportsTable';
import { Button } from '@/components/ui/daisy/button';
import { Divider } from '@/components/ui/daisy/divider';
import ScheduledLessonPlanItems from '@/components/scheduled-lesson/scheduled-lesson-plan-items/ScheduledLessonPlanItems';
import ScheduledLessonHomework from '@/components/scheduled-lesson/scheduled-lesson-homework/ScheduledLessonHomework';
import ScheduledLessonNotes from '@/components/scheduled-lesson/scheduled-lesson-notes/ScheduledLessonNotes';
import CopyScheduledLessonReportButton from '@/components/scheduled-lesson/CopyScheduledLessonReportButton';
import SubmitScheduledLessonBtn from '../SubmitScheduledLessonBtn';
interface ScheduledLessonReportProps {
  scheduledLesson: ScheduledLesson;
  klass: Klass;
  onClose?: () => void;
  cacheManager?: ListCacheManager<ScheduledLesson>;
}

export default function ScheduledLessonReportView({
  scheduledLesson,
  klass,
  onClose,
  cacheManager,
}: ScheduledLessonReportProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'manageScheduledLessonReport',
  });
  return (
    <>
      <div className="flex flex-col gap-6">
        <StudentsReportsTable klass={klass} scheduledLesson={scheduledLesson} />
        <Divider />
        <ScheduledLessonPlanItems
          scheduledLessonId={scheduledLesson.id}
          scheduledLessonPlanItems={scheduledLesson.scheduledLessonPlanItems}
        />
        <ScheduledLessonHomework
          scheduledLessonId={scheduledLesson.id}
          homeworkActivityId={scheduledLesson.homeworkActivity}
          hasHomeworkActivity={scheduledLesson.hasHomeworkActivity}
        />
        <ScheduledLessonNotes
          scheduledLessonId={scheduledLesson.id}
          notes={scheduledLesson.notes}
        />
        <CopyScheduledLessonReportButton
          scheduledLesson={scheduledLesson}
          klass={klass}
        />
      </div>
      <Divider />
      <div className="flex gap-3 items-end h-full">
        <Button className="flex-1" onClick={onClose}>
          {t('cancel')}
        </Button>
        <SubmitScheduledLessonBtn
          scheduledLesson={scheduledLesson}
          klass={klass}
          cacheManager={cacheManager}
        />
      </div>
    </>
  );
}
